import { Category, Product, ProductFilters } from "../../types";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import FiltersPanel from "../filters/FiltersPanel";
import SortBar from "../filters/SortBar";
import ProductsPanel from "../products/ProductsPanel";

interface CatalogContainerProps {
    products: Product[];
    total: number;
    filters: ProductFilters;
    updatePage: (page: number) => void;
    activeSort: string;
    handleSortChange: (
        sortBy: "created_at" | "price" | "name" | "rating",
        order: "asc" | "desc"
    ) => void;
    categories: Category[];
    categoriesLoading: boolean;
    categoriesError: string | null;
    productsLoading: boolean;
    productsError: string | null;
    applyFilters: (filters: ProductFilters) => void;
    resetFilters: () => void;
}

export default function CatalogContainer({
    products,
    total,
    filters,
    updatePage,
    activeSort,
    handleSortChange,
    categories,
    categoriesLoading,
    categoriesError,
    productsLoading,
    productsError,
    applyFilters,
    resetFilters,
}: CatalogContainerProps) {
    return (
        <div className="container mx-auto px-4 py-6">
            <Breadcrumbs />
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-14">
                <FiltersPanel
                    categories={categories}
                    categoriesLoading={categoriesLoading}
                    categoriesError={categoriesError}
                    filters={filters}
                    applyFilters={applyFilters}
                    resetFilters={resetFilters}
                />
                <div className="w-full">
                    <SortBar
                        filters={filters}
                        activeSort={activeSort}
                        handleSortChange={handleSortChange}
                    />
                    <ProductsPanel
                        products={products}
                        productsLoading={productsLoading}
                        productsError={productsError}
                        total={total}
                        filters={filters}
                        updatePage={updatePage}
                    />
                </div>
            </div>
        </div>
    );
}
